
import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

export const FlashIcon: React.FC<IconProps> = (props) => (
  <Icon
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path d="M8.66667 1.53833L2 9.53833H8L7.33333 14.8717L14 6.87166H8L8.66667 1.53833Z" fill="#64748B"/>
  </Icon>
);
